// GENERAL
export const BASE = '/';
export const HOME = '/home';
export const UNAUTHORIZED = '/unauthorized';
export const EVERYTHING_ELSE__MUST_BE_LAST = '/*';

// COMPLIANCE MODULE
export const COMPLIANCE_VIOLATIONS = '/compliance-violations';
export const COMPLIANCE_VIOLATIONS_DETAIL = '/compliance-violations/:complianceViolationId';
export const COMPLIANCE_VIOLATIONS_MANAGE_RECIPIENT = '/compliance-violations/:complianceViolationId/manage-recipients';

// ADVERTISER MODULE
export const ADVERTISERS = '/advertisers';
export const EDIT_ADVERTISER = '/edit-advertiser/:advertiserId';
export const CREATE_ADVERTISER = '/create-advertiser';
